/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/display-name */
import React from 'react';

import { FormattedMessage } from 'react-intl';

import messages from '../../components/CompanyName/CompanyName.messages';

const CompanySearchFooter =
    ({ hasMoreResults, toggleManualCompanyName }) =>
    () => {
        const text = hasMoreResults
            ? messages.filterMoreResultsText
            : messages.chooseCompanyHelperText;
        const linkText = hasMoreResults
            ? messages.filterMoreResultsLink
            : messages.chooseCompanyLinkText;
        const manualEntryLink = (
            <a onClick={toggleManualCompanyName}>
                <FormattedMessage {...linkText} />
            </a>
        );

        return (
            <div className="select-helper">
                <FormattedMessage {...text} values={{ manualEntryLink }} />
            </div>
        );
    };

export default CompanySearchFooter;
